/**
 * Cinema Mode Module
 * Handles feature image background effects
 */

function initCinemaMode() {
    const cinemaBackground = document.getElementById('cinema-mode-background');
    const cinemaImage = document.getElementById('cinema-mode-image');
    const cinemaGradient = document.getElementById('cinema-mode-gradient');
    const mainHeader = document.getElementById('main-header');
    const cinemaToggle = document.getElementById('cinema-mode-toggle');
    const featureImage = document.querySelector('main[data-feature-image]')?.dataset.featureImage;
    
    if (!cinemaBackground || !cinemaImage || !featureImage) return;
    
    if (cinemaToggle) cinemaToggle.classList.remove('hidden');
    
    cinemaImage.style.backgroundImage = `url('${featureImage}')`;
    
    let cinemaModeEnabled = localStorage.getItem('cinemaModeEnabled') !== 'false';
    
    if (cinemaToggle) {
        updateToggleButton(cinemaToggle, cinemaModeEnabled);
        
        cinemaToggle.addEventListener('click', () => {
            cinemaModeEnabled = !cinemaModeEnabled;
            localStorage.setItem('cinemaModeEnabled', cinemaModeEnabled);
            updateToggleButton(cinemaToggle, cinemaModeEnabled);
            handleCinemaScroll();
        });
    }
    
    extractImageColors(featureImage).then(colors => {
        if (colors?.length > 0) {
            const color1 = colors[0];
            const color2 = colors[1] || colors[0];
            cinemaGradient.style.background = `linear-gradient(to bottom, rgba(${color1.r},${color1.g},${color1.b},0.85), rgba(${color2.r},${color2.g},${color2.b},0.95))`;
            cinemaBackground.dataset.dominantColor = `${color1.r},${color1.g},${color1.b}`;
        }
    });
    
    let ticking = false;
    
    function handleCinemaScroll() {
        if (!cinemaModeEnabled) {
            cinemaBackground.style.opacity = '0';
            mainHeader.classList.remove('cinema-mode-active');
            mainHeader.style.borderBottomColor = '';
            return;
        }
        
        const scrollPosition = window.scrollY;
        const activationPoint = 100;
        const fullOpacityPoint = 300;
        
        if (scrollPosition > activationPoint) {
            const opacity = Math.min((scrollPosition - activationPoint) / (fullOpacityPoint - activationPoint), 1);
            cinemaBackground.style.opacity = opacity;
            
            if (opacity > 0.5) {
                mainHeader.classList.add('cinema-mode-active');
                mainHeader.style.borderBottomColor = 'rgba(255,255,255,0.1)';
            } else {
                mainHeader.classList.remove('cinema-mode-active');
                mainHeader.style.borderBottomColor = '';
            }
        } else {
            cinemaBackground.style.opacity = '0';
            mainHeader.classList.remove('cinema-mode-active');
            mainHeader.style.borderBottomColor = '';
        }
    }
    
    window.addEventListener('scroll', () => {
        if (ticking) return;
        
        window.requestAnimationFrame(() => {
            handleCinemaScroll();
            ticking = false;
        });
        ticking = true;
    });
    
    handleCinemaScroll();
}

function updateToggleButton(button, enabled) {
    if (enabled) {
        button.classList.add('bg-primary/10');
        button.title = 'Cinema Mode: ON (Click to disable)';
        button.querySelector('svg').style.color = 'var(--accent-color, #6366f1)';
    } else {
        button.classList.remove('bg-primary/10');
        button.title = 'Cinema Mode: OFF (Click to enable)';
        button.querySelector('svg').style.color = '';
    }
}

async function extractImageColors(imageSrc) {
    return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        
        img.onload = function() {
            try {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                canvas.width = 100;
                canvas.height = 100;
                
                ctx.drawImage(img, 0, 0, 100, 100);
                const imageData = ctx.getImageData(0, 0, 100, 100).data;
                
                const colorMap = {};
                
                for (let i = 0; i < imageData.length; i += 4) {
                    const r = Math.round(imageData[i] / 10) * 10;
                    const g = Math.round(imageData[i + 1] / 10) * 10;
                    const b = Math.round(imageData[i + 2] / 10) * 10;
                    const key = `${r},${g},${b}`;
                    colorMap[key] = (colorMap[key] || 0) + 1;
                }
                
                const sortedColors = Object.entries(colorMap)
                    .sort((a, b) => b[1] - a[1])
                    .slice(0, 2)
                    .map(([color]) => {
                        const [r, g, b] = color.split(',').map(Number);
                        return { r, g, b };
                    });
                
                resolve(sortedColors);
            } catch (e) {
                console.warn('Could not extract image colors:', e);
                resolve([{ r: 0, g: 0, b: 0 }, { r: 20, g: 20, b: 30 }]);
            }
        };
        
        img.onerror = () => {
            console.warn('Could not load image for color extraction');
            resolve([{ r: 0, g: 0, b: 0 }, { r: 20, g: 20, b: 30 }]);
        };
        
        img.src = imageSrc;
    });
}
